module.exports = "/images/ANTONIO_MARCO_DOS_SANTOS.jpg?ee217906e2834e21bd02f70585cac39d";